<template>
    <div class="ui-plc-footer">
        <div class="ui-plc-footer-container">
            <div class="nav-row main">
                <div class="st-footer-branding-section">
                    <div class="st-logo-mono"></div>
                    <div class="social-section p-0">
                        <div class="social-set">
                            <a href="https://open.spotify.com/user/fystyaogi6kcu7t8ul3bw36jr"
                                class="social-icon sp w-inline-block"></a>
                            <a href="https://www.instagram.com/songtools/" class="social-icon ig w-inline-block"></a>
                            <a href="https://twitter.com/SongTools" class="social-icon tt w-inline-block"></a>
                            <a href="https://www.facebook.com/SongTools" class="social-icon fb w-inline-block"></a>
                            <a href="https://www.youtube.com/channel/UCK_ASPnWC95x1BMzC0yF7hA"
                                class="social-icon youtube w-inline-block"></a>
                            <a href="https://www.linkedin.com/company/songtools/about/"
                                class="social-icon linkedin w-inline-block"></a>
                            <a href="https://www.tiktok.com/@songtools?lang=en" class="social-icon tiktok w-inline-block"></a>
                        </div>
                        <a href="/blog" target="_blank"
                            class="btn-primary inverted arrow footer w-button">Visit our blog</a>
                    </div>
                </div>
                <div class="footer-active-service-2">
                    <p class="footer-statement-2">
                        The world's leading music discovery platform and home to the largest community of independent
                        playlisters digging for new music.
                    </p>
                </div>
            </div>
            <div class="nav-row">
                <div class="st-services-nav">
                    <a href="/playlisterclub" class="nav-item-footer plc w-inline-block">
                        <img loading="lazy" src="/playlistability/assets/img/webflow/songtools-icon-playlisterclub_normal.svg" alt="">
                    </a>
                    <a href="/playlisterclub" class="nav-item-footer w-inline-block">
                        <img loading="lazy" height="24" src="/playlistability/assets/img/webflow/playlisterclub-logo-vector-white.svg"
                            alt="">
                    </a>
                    <a href="/songfly" class="nav-item-footer w-inline-block">
                        <img loading="lazy" height="24" src="/playlistability/assets/img/webflow/songfly-logo-vector-white.svg" alt="">
                    </a>
                    <a href="/songfolder" class="nav-item-footer w-inline-block">
                        <img loading="lazy" height="24" src="/playlistability/assets/img/webflow/songfolder-logo-vector-white.svg" alt="">
                    </a>
                    <a href="/songpage" class="nav-item-footer w-inline-block">
                        <img loading="lazy" height="24" src="/playlistability/assets/img/webflow/songpage-logo-vector-white.svg" alt="">
                    </a>
                    <a href="/songblog" class="nav-item-footer w-inline-block">
                        <img loading="lazy" height="24" src="/playlistability/assets/img/webflow/songblog-logo-vector-white.svg" alt="">
                    </a>
                </div>
            </div>
            <div class="nav-row"></div>
            <div class="sub-nav-row">
                <div class="legal-section">
                    <div class="legal-nav">
                        <a class="legal-link" href="mailto:info@playlister.club">Contact Us</a>
                    </div>
                    <div class="legal-nav">
                        <a href="/" class="legal-link">
                            Terms of Use
                        </a>
                    </div>
                    <div class="disclaimer">
                        <div class="disclaimer-txt-2">
                            © 2023 Pentatone Inc. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-active-logo-deco-2"></div>
        </div>
    </div>
</template>
<script>
export default {

};
</script>
<style lang="scss">

</style>
